import { useDispatch, useSelector } from "react-redux";
import { saveAlertMessage } from "./screens/redux/slice/alertMessage";
import { TOKEN } from "./screens/redux/api/Constants";
import AlertPopUp from "./components/Common/AlertPopup/alertPopup";
import { Spinner } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Main from "./screens/redux/slice/errorLogger";
import HttpClient from "./Services/HttpClient";
import ReactRoutes from "./ReactRoutes";
import { AdminProvider } from "./components/Common/FilterContext/AdminPanelContext";
import { Commet } from "react-loading-indicators";

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const alertMessage = useSelector((state) => state.alertMessage);
  let token = localStorage.getItem(TOKEN);

  const togglePopup = () => {
    dispatch(saveAlertMessage(null));
  };

  const [loading, setLoading] = useState(false);

  // const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (token) {
      HttpClient.defaults.headers.common["Authorization"] =
        `Bearer ${token}` || "";
    }

    HttpClient.interceptors.request.use(
      function (config) {
        // spinning start to show
        setLoader(true);
        return config;
      },
      function (error) {
        setLoader(false);
        return Promise.reject(error);
      },
    );

    HttpClient.interceptors.response.use(
      function (response) {
        // spinning hide
        setLoader(false);
        return response;
      },
      function (error) {
        setLoader(false);
        return Promise.reject(error);
      },
    );
  }, []);

  return (
    <div className="App">
      {loader && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.3)", // 👈 semi-transparent black
            zIndex: 1050, // above other elements
          }}
        >
          {/* <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div> */}
          {/* <BlinkBlur color="#852e59" size="medium" text="" textColor="" /> */}
          <Commet color="#852e59" size="medium" text="" textColor="" />
        </div>
      )}
      <AdminProvider>
        <ReactRoutes />
      </AdminProvider>
      {/* <Main/> */}

      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css"
      />
    </div>
  );
}

export default App;
